const PUBLIC_VAPID_KEY = "BFd-Ww1hey6QCA1VsZndwKmc860M-3M7nceHelSduvvmF0LQxI6cnmKOkdOJk4s6d4SKFaqBBhy2uc6yU9RRlRw"; // เอามาจาก PHP

// const PUBLIC_VAPID_KEY = '...'; // Base64 public key

export async function subscribeUserToPush() {
    alert("🔔 Subscribe to Push Notifications");
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

  // 1. ขอ permission
  if (Notification.permission !== "granted") {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      alert("🚫 Notification permission not granted");
      return;
    }
  }

  try {
    const registration = await navigator.serviceWorker.ready;

    // 2. เช็คว่ามี subscription เดิมไหม
    // const existingSubscription = await registration.pushManager.getSubscription();
    // if (existingSubscription) {
    //   console.log("🟡 Already subscribed");
    //   return;
    // }

    // 3. สมัครใหม่
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(PUBLIC_VAPID_KEY),
    });

    // 4. ส่งไปหลังบ้าน
    const res = await fetch("./api/save-subscription.php", {
      method: "POST",
      body: JSON.stringify(subscription),
      headers: { "Content-Type": "application/json" }
    });

    console.log("✅ Subscribed:", subscription);
  } catch (err) {
    alert("❌ Push Error:", err);
  }
}


// Helper function แปลง base64 เป็น Uint8Array
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return new Uint8Array([...rawData].map(char => char.charCodeAt(0)));
}